<template>
    <div class="product">
        <div class="floor">
            <div class="wrapper-teacher">
                <div class="btn" @click="loginTeacherWeb">老师端网页登录</div>
            </div>
        </div>
        <div class="floor"></div>
        <div class="floor">
            <div class="wrapper">
                <!-- <div class="btn" @click="jump">点击下载PC端</div> -->
            </div>
        </div>
      <div class="floor"></div>
      <!--div class="floor">
          <div class="wrapper">
              <div class="btn" @click="jump">点击下载PC端</div>
          </div>
      </div-->
        <!-- <div class="floor"></div> -->
        <!-- <div class="floor"></div>
        <div class="floor"></div> -->
        <!-- <div class="floor"></div> -->
    </div>
</template>
<script>
    import { Component, Vue } from 'vue-property-decorator';

    @Component({
		components: {}
	})
	export default class Product extends Vue {
        aiclass = 'https://xiaoheketang.knowbox.cn';
        program = 'https://xiaoheketang.knowbox.cn';

        jump() {
            window.open('https://xiaoheketang.knowbox.cn/download');
        }
        loginTeacherWeb() {
            window.open('https://teacher.knowbox.cn');
        }
    }
</script>
<style lang="scss">
    .product {
        margin-top: 100px;
        .floor {
            height: 951px;
            background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-1@x2.jpg) top center no-repeat;
            background-size: cover;
            .wrapper-teacher {   
                    position: absolute;
                    left: 50%;
                    height: 951px;
                    margin-left: -270px;
                    .btn {
                        position: absolute;
                        bottom: 25px;
                        right: 0;
                        font-family: PingFangSC-Semibold;
                        font-size: 24px;
                        color: #fff;
                        background: #f69600;
                        border-radius: 26px;
                        cursor: pointer;
                        width: 246px;
                        height: 54px;
                        line-height: 54px;
                        text-align: center;
                    }
                }
            &:nth-child(2) {
                height: 888px;
                background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-2@x2.jpg);
            }
            &:nth-child(3) {
                height: 822px;
                background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/bg_xhxx_product.png);
                position: relative;
                .wrapper {
                    position: absolute;
                    left: 50%;
                    height: 77%;
                    margin-left: -270px;
                    .btn {
                        position: absolute;
                        bottom: 25px;
                        right: 0;
                        font-family: PingFangSC-Semibold;
                        font-size: 24px;
                        color: #fff;
                        background: #f69600;
                        border-radius: 26px;
                        cursor: pointer;
                        width: 246px;
                        height: 54px;
                        line-height: 54px;
                        text-align: center;
                    }
                }
            }
            &:nth-child(4) {
                height: 823px;
                background-image: url(https://susuanqiniu.knowbox.cn/20220214-knowbox.cn.jpg);
            }
            /*&:nth-child(4) {
                height: 605px;
                background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-4@x2.jpg);
            }*/
            //&:nth-child(5) {
            //    height: 0;
            //    background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-5@x2.jpg);
            //}
            // &:nth-child(6) {
            //     height: 773px;
            //     background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-6@x2.jpg);
            // }
            // &:nth-child(7) {
            //     height: 603px;
            //     background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-7@x2.jpg);
            // }
            //&:nth-child(6) {
            //    height: 0;
            //    background-image: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/product/floor-8@x2.jpg);
            //}
        }
    }
</style>
